// Dependencies
import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal as ModalRM } from 'react-responsive-modal';

export default function Modal(props) {
  return <ModalRM focusTrapped={false} {...props} />;
}
